import { Injectable } from '@angular/core';
import { CacheListener } from './@utils/cache-listener';
import dexFreight from './microservices';
import { AuthService } from '@services';
import { Subscription } from 'rxjs';

export interface AvailableGPS {
  id: string;
  name: string;
  registered: boolean;
  referencesName: string;
  availableReferences: string[];
}

@Injectable({
  providedIn: 'root'
})
export class GpsService {

  list = new CacheListener<AvailableGPS[]>('gps-list', [], this.syncGpsList.bind(this));
  listeners: Subscription[] = [];

  constructor(
    private authService: AuthService
  ) { }

  setupListeners() {
    this.listeners.push(
      this.list.syncWhenChanges(this.authService.token)
    );
  }

  removeListeners() {
    this.listeners.forEach(listener => listener.unsubscribe());
  }

  async syncGpsList() {
    const token = await this.authService.token.get();
    if (!token) {
      return [];
    }
    
    return await dexFreight.Tracking.gpsProviders(token);
  }
}
